import { get, post } from '@/utils/request';

export const queryContract = (params) => {
  return post('/api/v1/query_contract', params);
};

export const exportContractsByPuser = (params) => {
  return get('/api/v1/platform/export_report', params);
};

export const contract_statuss = (params) => {
  return get('/api/v1/contract_statuss', params);
};
